// Where a notification takes its reader, as a route the app can open: its
// `link`, when it is one of the app's own paths ("/loto/12/345", the machine a
// lockout assignment is about). Anything else, another site or a
// protocol-relative "//host", is not followed: null, and the notification
// simply has nowhere to go.
export function notificationRoute(notification) {
  const link = notification && notification.link
  if (typeof link !== 'string') return null
  if (!link.startsWith('/') || link.startsWith('//')) return null
  return link
}
